<template>
  <div>
    <div class="content w-1200">
      <div class="top-box">
        <el-form label-position="left" :model="form" label-width="80px">
          <el-row>
            <el-col :span="6" :offset="1">
              <el-form-item label="cas">
                <el-input v-model="form.cas_no" placeholder="请输入cas号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-form-item label="订单编号">
                <el-input v-model="form.orderno" placeholder="请输入订单号"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-form-item label="发布时间">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="form.created_at"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" :offset="10" class="flex-end pad-top-inner">
              <gradient-button background="#0C60E6" @hit="handleSearch"
              >搜索
              </gradient-button
              >
              <gradient-button
                  color="#5F616C"
                  border="1px solid #5F616C"
                  background="transparent"
                  @hit="handleReset"
              >刷新
              </gradient-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="ter-bars">
        <div class="left-title hit-cursor">
          <div
              v-for="item in terbars"
              :key="item.value"
              :class="['ter-bar-item', form.state === item.value ? 'active' : '']"
              @click="handleTarBar(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="right-add">
          <gradient-button background="#0C60E6" @hit="handleAdd"
          >发布询单
          </gradient-button
          >
        </div>
      </div>
      <div class="fotter-box">
        <div class="teble-box" v-loading="loading">
          <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{
              backgroundColor: '#F6F6F8',
              color: '#00112B',
              textAlign: 'center',
            }"
              :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" width="50" label="序号" fixed="left">
            </el-table-column>
            <el-table-column prop="orderno" label="订单编号" width="200"/>
            <el-table-column prop="type" label="订单类型" width="100">
              <template slot-scope="scope">
                <el-tag type="warning" v-if="scope.row.type==2">商城订单</el-tag>
                <el-tag type="danger" v-if="scope.row.type==1">采购订单</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="中文名称" width="200"/>
            <el-table-column prop="cas_no" label="CAS编号" width="150">
            </el-table-column>
            <el-table-column prop="total_price" label="价格" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_price }}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <!-- 1待付款 2已付款 3交易完成 4待评价 -->
                <el-tag type="info" v-if="scope.row.status == 1&&scope.row.pay_submit!=1">待付款</el-tag>
                <el-tag type="warning" v-if="scope.row.status == 1&&scope.row.pay_submit==1">等待确认收款</el-tag>
                <el-tag v-if="scope.row.status == 2">待发货</el-tag>
                <el-tag v-if="scope.row.status == 3">待发货</el-tag>
                <el-tag type="danger" v-if="scope.row.status == 4">待收货</el-tag>
                <el-tag type="success" v-if="scope.row.status == 5">交易完成</el-tag>
                <el-tag type="danger" v-if="scope.row.status == -1">已取消</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="supply" label="供应商" width="160" v-if="userInfo.vip_status==1">
              <template slot-scope="scope">
                <template v-if="scope.row.supply">
                  <div>{{ scope.row.supply.realname }}</div>
                  <div>{{ scope.row.supply.mobile }}
                    <span class="color-blue" @click="copyText(scope.row.supply.mobile)">
                    <i class="el-icon-copy-document"></i>
                  </span>
                  </div>
                </template>
                <template v-else>
                  <div>/</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="yewu" label="联系业务" width="160">
              <template slot-scope="scope" v-if="scope.row.yewu">
                <div>{{ scope.row.yewu.name }}</div>
                <div>{{ scope.row.yewu.mobile }}
                  <span class="color-blue" @click="copyText(scope.row.yewu.mobile)">
                  <i class="el-icon-copy-document"></i>
                </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="发布时间" width="160"/>
            <el-table-column prop="endtime" label="合同" width="150">
              <template slot-scope="scope">
                <a
                    class="color-blue"
                    v-if="scope.row.buy_contract"
                    :href="scope.row.buy_contract"
                    target="_blank"
                >点击查看合同</a
                >
                <el-button
                    type="text"
                    v-else-if="scope.row.status >= 2 && scope.row.is_apply_contract == 2"
                    size="small"
                    @click="handleApplyContract(scope.row)"
                >申请合同
                </el-button>
                <el-button
                    type="text"
                    v-else-if="scope.row.status >= 2"
                    size="small"
                >等待上传
                </el-button>
                <el-button
                    type="text"
                    v-else
                    size="small"
                >确认收款后可申请合同
                </el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="buy_invoice" label="发票" width="150">
              <template slot-scope="scope">

                <el-button
                    type="text"
                    v-if="scope.row.status <5"
                    size="small"
                >订单完成后可申请发票
                </el-button
                >
                <template v-else>
                  <a
                      class="color-blue"
                      v-if="scope.row.buy_invoice"
                      :href="scope.row.buy_invoice"
                      target="_blank"
                  >点击查看发票</a
                  >
                  <el-button
                      type="text"
                      v-else
                      size="small"
                      @click="handleApplyInvoice(scope.row)"
                  >申请发票
                  </el-button
                  >
                  <el-button
                      type="text"
                      v-else
                      size="small"
                  >等待上传
                  </el-button
                  >
                </template>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="technology" label="发货单" width="150">
              <template slot-scope="scope">
                <a
                    class="color-blue"
                    :href="linkPath + '/test-label?id=' + scope.row.id"
                    target="_blank"
                >点击打印发货单</a
                >
              </template>
            </el-table-column> -->
            <el-table-column prop="getAddress" label="收货地" width="300">
              <template slot-scope="scope">
                <span
                >{{ scope.row.address.province }}
                  {{ scope.row.address.city }}
                  {{ scope.row.address.area }}</span
                >
                <span>{{ scope.row.address.address }}</span>
              </template>
            </el-table-column>

            <el-table-column
                prop="operation"
                label="操作"
                fixed="right"
                width="200"
            >
              <template slot-scope="scope">
                <el-button
                    @click="handleDetail(scope.row)"
                    type="text"
                    size="small"
                >查看
                </el-button
                >
                <el-button
                    type="text"
                    v-if="scope.row.status == 4"
                    size="small"
                    @click="handleConfirmReceipt(scope.row)"
                >确认收货
                </el-button
                >
                <el-button
                    type="text"
                    v-if="scope.row.status == 1&&scope.row.pay_submit!=1"
                    size="small"
                    @click="handlePay(scope.row)"
                >去付款
                </el-button>
                <el-button
                    type="text"
                    v-if="
                     scope.row.status >= 5&&!scope.row.buy_invoice
                  "
                    size="small"
                    @click="handleApplyInvoice(scope.row)"
                >申请发票
                </el-button
                >
                <el-button
                    type="text"
                    v-if="
                   scope.row.status >= 2 && scope.row.is_apply_contract == 2
                  "
                    size="small"
                    @click="handleApplyContract(scope.row)"
                >申请合同
                </el-button
                >
                <el-button
                    type="text"
                    v-if="scope.row.status == 1&&scope.row.pay_submit!==1"
                    size="small"
                    @click="handleDelete(scope.row)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
              class="float-right"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--    详情弹窗-->
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        title="采购订单详情"
        :visible.sync="detailDialogVisible"
        :before-close="handleCloseDetail"
        width="50%"
    >
      <div class="detail-content">
        <div class="detail-left" v-if="detail">
          <!-- <img :src="detail.product.image" alt="" v-if="detail.product.image">
         -->
          <div class="detail-right">
            <table class="custom-table" border="1">
              <tr>
                <td>订单编号</td>
                <td>{{ detail.orderno }}</td>
                <td>订单价格</td>
                <td>{{ detail.total_price }}</td>
              </tr>
              <tr>
                <td>产品名称</td>
                <td>{{ detail.product_name }}</td>
                <td>CAS编号</td>
                <td>{{ detail.cas_no }}</td>
              </tr>
              <tr>
                <td>产品数量</td>
                <td>{{ detail.cart_num || 1 }}</td>
                <td>产品单价</td>
                <td>{{ detail.unit_price }}元</td>
              </tr>
              <tr>
                <td>规格</td>
                <td v-if="detail.type==1">{{ detail.purity }}%,{{ detail.unit }} (纯度，重量)</td>
                <td v-if="detail.type==2">{{ detail.unit }} (纯度，重量)</td>
                <td>支付方式</td>
                <td>{{ detail.pay_type }}</td>
              </tr>
              <tr v-if="detail.status>=4">
                <td>快递公司</td>
                <td>{{ detail.express_company }}
                  <el-button
                      type="text"
                      size="small"
                      @click="viewExpressInfo()"
                  >
                    查看快递
                  </el-button>
                </td>
                <td>快递单号</td>
                <td>{{ detail.express_order }}</td>
              </tr>
              <tr v-if="detail.address">
                <td>收货地址</td>
                <td colspan="3">
                  {{ detail.address.province }} {{ detail.address.city }}
                  {{ detail.address.area }} {{ detail.address.address }}
                </td>
              </tr>
              <tr v-if="userInfo.member_type==2&&is_vip">
                <td>备注</td>
                <td colspan="3">
                  {{ detail.remark || "--" }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 快递信息弹窗 -->
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        title="快递信息"
        :visible.sync="expressDialogVisible"
        width="50%"
    >
      <div>
        <el-timeline :reverse="true">
          <el-timeline-item
              v-for="(item,index) in expressList"
              :key="index"
              :timestamp="item.time"
              placement="top"
          >
            <div>
              <p>{{ item.context }}</p>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <el-empty v-if="expressList.length==0" description="还没有物流信息哦~"/>
      <span slot="footer" class="dialog-footer">
    <el-button @click="expressDialogVisible = false">关闭</el-button>
  </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  purchase_order,
  purchaseDetail,
  purchase_order_detail,
  confirm_receipt,
  apply_contract,
  apply_invoice,
} from "@/api/modules/user";
import GradientButton from "@/components/button/gradient-button.vue";
import {express} from "../../../api/modules/home";
import {deleteOrder} from "../../../api/modules/common";
import Empty from "../../../components/public/empty.vue";
import {mapGetters} from "vuex";

export default {
  name: "order",

  components: {
    Empty,
    GradientButton,
  },
  data() {
    return {
      expressDialogVisible: false,
      currentOrderId: null,
      linkPath: this.$api.linkPath,
      form: {
        cas_no: "",
        created_at: [],
        state: "0",
        orderno: '',
      },
      terbars: [
        {
          label: "全部",
          value: "0",
        },
        {
          label: "待付款",
          value: "1",
        },
        {
          label: "待发货",
          value: "2",
        },
        {
          label: "待收货",
          value: "3",
        },
        {
          label: "交易完成",
          value: "4",
        },
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      detail: {},
      detailDialogVisible: false,
      loading: false,
      expressList: []
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'is_vip']),
  },
  created() {
    this.getList();
  },
  methods: {
    // 复制文本
    copyText(text) {
      this.$utils.copyText(text, this);
    },
    // 删除订单
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await deleteOrder(row.id)
        if (res.data.code == 10000) {
          this.getList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      })
    },
    // 点击查看快递弹窗
    viewExpressInfo() {
      express(this.detail.id).then(res => {
        if (res.data.data) {
          this.expressList = res.data.data;
          this.expressDialogVisible = true;
        } else {
          this.$message.error(res.data.message);
        }

      });
    },
    // 刷新
    handleReset() {
      this.form = {
        cas_no: "",
        orderno: '',
        created_at: [],
      };
      this.page = 1;
      this.getList();
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    // 申请发票
    handleApplyInvoice(row) {
      this.$router.push({
        path: "/operate/applyInvoice",
        query: {
          order_id: row.id,
        },
      });
    },
    // 去付款
    handlePay(row) {
      this.$router.push({
        path: "/shop/bay",
        query: {
          order_id: row.id,
          re_pay:1
        },
      });
    },
    // 申请合同
    handleApplyContract(row) {
      apply_contract(row.id).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.getList();
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    // 确认收货
    handleConfirmReceipt(row) {
      confirm_receipt(row.id).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.getList();
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    // 查看
    handleDetail(row) {
      purchase_order_detail(row.id).then((res) => {
        this.detail = res.data.data;
        if (this.detail.pay_type == 'remit_alipay') {
          this.detail.pay_type = '线下支付宝转账'
        } else if (this.detail.pay_type == 'remit_bank') {
          this.detail.pay_type = '线下银行卡汇款'
        } else if (this.detail.pay_type == 'alipay') {
          this.detail.pay_type = '支付宝'
        } else if (this.detail.pay_type == 'wechat_jsapi') {
          this.detail.pay_type = '微信支付'
        } else if (this.detail.pay_type == 'wechat_native') {
          this.detail.pay_type = '微信扫码支付'
        } else {
          this.detail.pay_type = '--'
        }
        this.detailDialogVisible = true;
      });
    },
    // 关闭详情弹窗
    handleCloseDetail() {
      this.detailDialogVisible = false;
    },
    getList() {
      this.loading = true;
      let data = this.form;
      data.page = this.page;
      data.limit = this.pageSize;
      purchase_order(data).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    handleTarBar(value) {
      this.form.state = value;
      this.page = 1;
      this.getList();
    },
    // 发布采购
    handleAdd() {
      if (this.mixCheckUserAudit()) {
        this.$router.push("/user/purchase/release");
      }
    },
    handleRelease() {
      this.$router.push("/user/purchase/release");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handlePayImage(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped lang="scss">

.pad-top-inner {
  padding-top: 20px;
}

.color-blue {
  color: #2979f1;
  text-decoration: none;
}

.custom-table {
  width: 100%;
  border-collapse: collapse; /* 关键：合并边框 */
  border-color: #f3f3f3;
  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3) {
    padding: 10px 24px;
    background: #f9faff;
    text-align: center;
    color: #5f616c;
  }

  td:nth-child(2),
  td:nth-child(4) {
    padding: 10px 24px;
    border: 1px solid #f3f3f3;
    color: #00112b;
  }
}

.content {
  padding: 0 0 20px;

  .fotter-box {
    // height: 635px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    // margin-top: 20px;
    .pagination-box {
      padding: 20px;

      .float-right {
        float: right;
      }
    }
  }

  .top-box {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner {
      width: 15vw;
    }

    // height: 220px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 30px 0;

    .search-btn {
      width: 120px;
      // height: 50px;
      background: #1890ff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2979f1;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      // line-height: 50px;
    }

    .reset-btn {
      width: 120px;
      // height: 50px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
      // line-height: 50px;
      text-align: center;
    }
  }

  .ter-bars {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .left-title {
      line-height: 28px;
      display: flex;
      align-items: center;
      gap: 50px;

      .ter-bar-item {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
        border-bottom: 4px solid transparent;
      }

      .active {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
        border-bottom: 4px solid #1890ff;
      }
    }
  }
}
</style>
